import gql from 'graphql-tag';

export const DISTRIBUTION_SCHEDULE = gql`
    query MutualFund($ticker: String!) {
        mutualFund(ticker: $ticker) {
            capitalGainFrequency
            dividendFrequency
        }
    }
`;

export const CAPITAL_GAINS = gql`
    query CapitalGains($ticker: String!) {
        mutualFund(ticker: $ticker) {
            capitalGainPayments {
                capGainPayDate
                shortTermGain
                longTermGain
                capGainReinvestmentPrice
            }
        }
    }
`;

export const DIVIDENDS_PAYMENTS = gql`
    query DividendPayments($ticker: String!) {
        mutualFund(ticker: $ticker) {
            dividendPayments {
                dividendPayDate
                dividendReinvestmentPrice
                dividendAmt
            }
        }
    }
`;

export const ALTERNATIVE_MINIMUM_TAX = gql`
    query AlternativeMinimumTax($ticker: String!) {
        mutualFund(ticker: $ticker) {
            percentBondInvestedAMT
            monthlyComponentsAsOfDate
        }
    }
`;
